import { getCurrentAuthUser } from '@/services/authSession';

/**
 * Get the current authenticated user's ID (if any)
 */
export const getCurrentUserId = async (): Promise<string | null> => {
  const user = await getCurrentAuthUser();
  return user?.id ?? null;
};
